import {ACTION} from './constants';

let initialState={
   iapWomenData:{},
   registerData:"Register",
   sipPopData:{},
   iapWomenMCQ:{},
   saheliMetaData:{},
   registerRegistrationData: "Register",
   registrationSubmit: {}
};

export default function IAPWomenReducer(state=initialState, action) {
   switch (action.type) {
         case ACTION.GET_IAP_WOMEN_CONTENT :
            return {...state, iapWomenData:{...action.data}};
         case ACTION.WEBINAR_REGISTRATION :
            return {...state, registerData:{...action.data}};
         case ACTION.GET_SIP_SAHELI_POPUP :
            return {...state, sipPopData:{...action.data}};
         case ACTION.GET_IAP_WOMEN_MCQ :
            return {...state, iapWomenMCQ:action.data};
         case ACTION.SIP_SAHELI_META:
            return { ...state, saheliMetaData: { ...action.data }};
         case ACTION.SUBMI_EVENT_MCQ:
            return { ...state, eventRegistrationMCQ: { ...action.data }};
         case ACTION.GET_IAP_REGISTRATION_DATA:
            return { ...state, registrationData: { ...action.data }};
         case ACTION.REGISTER_REGISTRATION :
            return {...state, registerRegistrationData:{...action.data}};
         case ACTION.REGISTER_SUBMI_MCQ:
            return { ...state, registrationSubmit: { ...action.data }};
         case ACTION.REGISTER_MEDIA :
            return {...state, registerMediaData:action.data};
         default:
           return state;
   };
};